import React from 'react';
import {Input} from "reactstrap";

export class DaysOfTheWeekBooleans extends React.Component {
    constructor(props) {
        super(props);
        this.handleWeekdayChange = this.handleWeekdayChange.bind(this);
        this.state = {
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
            name: ""
        }
    }

    handleWeekdayChange(event) {
        const target = event.target;
        const value = target.checked;
        const name = target.name;

        this.props.onWeekdayChange(name, value)
    }

    render() {
        return (<div key="weekday">
                <label>{this.props.label}</label><br/>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.monday}
                               name={this.props.name + "_monday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Lunes</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.tuesday}
                               name={this.props.name + "_tuesday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Martes</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.wednesday}
                               name={this.props.name + "_wednesday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Miércoles</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.thursday}
                               name={this.props.name + "_thursday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Jueves</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.friday}
                               name={this.props.name + "_friday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Viernes</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.saturday}
                               name={this.props.name + "_saturday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Sábado</p>
                    </div>
                </div>

                <div className="toggle-input-header" style={{display: "inline-flex"}}>
                    <label className="switch" style={{marginLeft: "0px"}}>
                        <Input type="checkbox" onChange={this.handleWeekdayChange}
                               checked={this.props.sunday}
                               name={this.props.name + "_sunday"}/>
                        <span className="slider"></span>
                    </label>
                    <div className="combined-label">
                        <p className="combined-label-title"
                           style={{paddingLeft: "10px", paddingRight: "20px"}}>Domingo</p>
                    </div>
                </div>
            </div>
        )
    }
}
